import _regenerator from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import { __decorate } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
import { getCouponList } from '@/api/coupon';
import Pagination from '@/components/Pagination/index.vue';
import UpsertModal from './conponents/UpsertModal.vue';
import UserList from './user/index.vue';
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    var _this;
    _classCallCheck(this, default_1);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, default_1, [].concat(args));
    _defineProperty(_this, "listLoading", false);
    _defineProperty(_this, "selectedRow", {
      event_coupon_id: 0,
      name: '',
      use_start_date: '',
      use_end_date: '',
      benefit_period: 0,
      benefit_type: 0,
      stock: 0,
      stock_free_yn: '',
      coupon_type: 0
    });
    _defineProperty(_this, "total", 0);
    _defineProperty(_this, "list", []);
    _defineProperty(_this, "listQuery", {
      page: 1,
      size: 5
    });
    _defineProperty(_this, "updateModal", {
      showDialog: false,
      isEdit: false
    });
    return _this;
  }
  _inherits(default_1, _Vue);
  return _createClass(default_1, [{
    key: "handleCurrentChange",
    value: function handleCurrentChange(value) {
      this.selectedRow = value;
    }
  }, {
    key: "handleCouponAdd",
    value: function handleCouponAdd() {
      if (this.selectedRow === null || this.selectedRow === undefined) {
        this.selectedRow = {};
        this.selectedRow.event_coupon_id = 0;
      }
      this.updateModal.showDialog = true;
      this.updateModal.isEdit = false;
    }
  }, {
    key: "handleCouponEdit",
    value: function handleCouponEdit(index, row) {
      this.selectedRow = row;
      this.updateModal.showDialog = true;
      this.updateModal.isEdit = true;
    }
  }, {
    key: "filterCouponType",
    value: function filterCouponType(couponType) {
      if (couponType === 1) {
        return this.$t('coupon.list.type.welcomeCoupon');
      }
    }
  }, {
    key: "getList",
    value: function () {
      var _getList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var data, temp, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              this.listLoading = true;
              _context.p = 1;
              _context.n = 2;
              return getCouponList(this.listQuery);
            case 2:
              data = _context.v;
              this.list = data.list;
              this.total = data.total_count;
              if (this.list.length > 0) {
                this.selectedRow = this.list[0];
              } else {
                temp = {
                  event_coupon_id: 0,
                  name: '',
                  use_start_date: '',
                  use_end_date: '',
                  benefit_period: 0,
                  benefit_type: 0,
                  stock: 0,
                  stock_free_yn: '',
                  coupon_type: 0
                };
                this.selectedRow = temp;
              }
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              this.listLoading = false;
            case 4:
              this.listLoading = false;
            case 5:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3]]);
      }));
      function getList() {
        return _getList.apply(this, arguments);
      }
      return getList;
    }()
  }, {
    key: "modalComplete",
    value: function modalComplete() {
      if (!this.updateModal.isEdit) {
        this.listQuery.page = 1;
      }
      this.getList();
    }
  }, {
    key: "created",
    value: function () {
      var _created = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return this.getList();
            case 1:
              if (this.total > 0) {
                this.selectedRow = this.list[0];
              }
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function created() {
        return _created.apply(this, arguments);
      }
      return created;
    }()
  }]);
}(Vue);
default_1 = __decorate([Component({
  name: 'Coupon',
  components: {
    Pagination: Pagination,
    UpsertModal: UpsertModal,
    UserList: UserList
  },
  filters: {
    benefitType: function benefitType(_benefitType) {
      if (_benefitType === 1) {
        return 'Free';
      }
      return 'N/A';
    },
    stock: function stock(_stock, stockFreeYn) {
      if (stockFreeYn === 'Y') {
        return '∞';
      }
      return _stock;
    }
  }
})], default_1);
export default default_1;